import { GetMoreContactsForAccountsBtn } from "../ui/GetMoreContactsForAccountsBtn";
import { GoToActionBlock } from "./GoToActionBlock";

export const GetContactsBlock = ({ campaign_id }: { campaign_id: string }) => {
  return (
    <GoToActionBlock
      title="No Contacts Data"
      texts={[
        "Gain buying committee insights by running an up-to-date contact search.",
      ]}
      btn={<GetMoreContactsForAccountsBtn campaign_id={campaign_id} />}
    />
  );
};
